import React from "react";
import Table from "../Shared/Table";

import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";

import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { elevatorCompany } from "core/UrlEndpoints";
import { useHistory } from "react-router-dom";
import { redirectToPath, paths } from "utils/PathService";

const List = () => {
  const history = useHistory();

  return (
    <>
      <PanelHeader
        content={
          <div className="header text-center">
            <h2 className="title">Elevator Companies</h2>
          </div>
        }
      />
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Elevator Companies</CardTitle>
                <Button
                  color="primary"
                  onClick={() => redirectToPath(paths.elevatorCompany.add)}>
                  Add
                </Button>
              </CardHeader>
              <CardBody>
                <Table
                  url={elevatorCompany}
                  columns={[
                    {
                      header: "Name",
                      accessorKey: "name",
                    },
                    {
                      header: "Address",
                      accessorKey: "line1",
                      cell: ({ row }) => (
                        <>
                          {row.original.line1} {row.original.line2},{" "}
                          {row.original.city} {row.original.state}
                        </>
                      ),
                    },
                    {
                      header: "DIDs",
                      accessorKey: "dids",
                      accessorFn: row => row.dids?.map(d => d.phoneNumber).join(", ") || "",
                      cell: ({ row }) => (
                        <>
                          {row.original.dids?.map(d => d.phoneNumber).join(", ")}
                        </>
                      )
                    },
                    {
                      header: "SMS DID",
                      accessorKey: "smsDID",
                    }

                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default List;
